module.exports = __webpack_public_path__ + "img/tarjeta_servicios_asistencia_auto.535acbf5.jpg";